//@flow
import type DataTables from 'datatables.net';

export default class BaseFilter {
    callback: () => void;
    invoke: () => void;
    column: ?string;

    constructor(callback: () => void) {
        this.callback = callback;
        this.column = null;
    }

    prime(column: ?string, func: () => void) {
        this.invoke = () => {
            this.column = column;
            func.bind(this)();
            this.callback();
        }
        return this;
    }

    addFilter(): void {
        throw 'addFilter is not defined for this filter.';
    }
    setFilter(): void {
        throw 'setFilter is not defined for this filter.';
    }
    clearFilter(): void {
        throw 'clearFilter is not defined for this filter.';
    }

    apply(dataTable: DataTables.Api) {}
    asFunction(): (void | ((settings: any, data: any, dataIndex: number,
                            columnIndex: {[string]: number}) => boolean)) {}

    getDescription() {
        return {}
    }
}